import React from 'react'
import Barcode from 'react-barcode';

export const Print_barcode_page = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
        <div className="barcode_show">
            <div className="w-full flex justify-center text-sm">
                {props?.name}
            </div>
            <div className="w-full flex justify-center ">
                {props?.price}
            </div>
            <div className="w-full flex justify-center ">
                <Barcode
                    value={props?.barcode} 
                    width={1.1} 
                    height={24} 
                    fontSize={12}
                    // displayValue={false}
                />
            </div>
        </div>
    </div>
  );
});